import mitt from 'mitt'

export function marketplaceAvailable(value) {
  const domains = [
    'jumpshop.oncollectible.com',
    'jumpshop-dev.oncollectible.com',
    'market.oncollectible.com',
    'market-dev.oncollectible.com',
  ]

  return domains.includes(value)
}

export function whitelabelDomain() {
  const domains = [
    {
      name: 'Jumpshop',
      website: ['jumpshop.oncollectible.com', 'jumpshop-dev.oncollectible.com'],
      publisherWebsite: ['publisher-jumpshop.collectible.cloud', 'publisher-jumpshop-dev.collectible.cloud'],
    },
  ]

  let data = domains.find((d) => d.publisherWebsite.includes(window.location.hostname))
  if (data) {
    let config = whitelabelConfig(data.website[0])
    let mktConfig = marketplaces.find((m) => m.host === config.host)
    return {
      isWhitelabel: true,
      config: {
        ...config,
        ...mktConfig,
      },
    }
  }

  return {
    isWhitelabel: false,
    config: null,
  }
}

export function whitelabelConfig(domain) {
  const configs = marketplaces

  return configs.find((c) => c.host === domain)
}

export const marketplaces = [
  {
    t: 'Jumpshop',
    host: 'jumpshop.oncollectible.com',
    code: 'ABKK',
    logo: '',
    favicon: '',
    primaryColor: '#000000',
    secondaryColor: '#ffffff',
    backgroundColor: '#ffffff',
  },
]

export const emitter = mitt()
